<template>
    <footer class="footer">
        <!-- ** Left side ** -->
        <div class="footer__author">
            <span>©</span>
            <span>DinkyDev</span>
        </div>

        <!-- ** Middle side ** -->
        <button class="footer__arrow" @click="goNextOrBack()" :title="getButtonTitle()" v-if="withButton">
            <span :class="getArrowIconClass()"></span>
        </button>

        <!-- ** Right side ** -->
        <div class="footer__contact">
            <router-link to="/contact">Contattaci</router-link>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    props: {
        enableButton: Boolean,
        withButton: Boolean,
    },
    computed: {
        /**
         * It is for the position of the arrow in the button:
         * defines if it goes next or back when it's clicked.
         */
        showGoBack: {
            get () {
                return !this.$store.state.slide.clickToNext
            },
            set (newValue) {
                return newValue
            }
        },
    },
    methods: {
        /**
         * Returns css classes for the element cointaining the arrow button.
         */
        getArrowIconClass: function () {
            return {
                'icon-arrow-right': true,
                'hidden': !this.enableButton,
                'icon--back': this.showGoBack,
                'icon--next': !this.showGoBack,
            }
        },
        /**
         * Retunrs the text showed when the mouse goes hover the button.
         */
        getButtonTitle: function () {
            return this.showGoBack ? 'Back' : 'Next'
        },
        /**
         * Moves slides inside the viewport.
         * In some cases moves to the next slide,
         * in other cases it moves to the previous slide.
         */
        goNextOrBack: function () {
            const progressMutation = this.showGoBack ? 'slide/decrement' : 'slide/increment'
            const slideMutation = this.showGoBack ? 'prev' : 'next'

            this.$store.commit(progressMutation)
            this.$store.commit(`${this.$route.name}/${slideMutation}`)
        }
    },
}
</script>

<style lang="scss">
    .footer{
        align-items: center;
        display: flex;
        font-family: $josefin;
        font-size: 19.5px;
        font-weight: bold;
        height: 40px;
        justify-content: space-between;
        width: 100%;

        &__arrow{ display: none; };
    }

    @media (min-width: $tablet-screen) {
        .footer__arrow{
            display: block;
            opacity: 0.7;
            transition: opacity 0.5s ease;

            &:hover{
                opacity: 1;

                span{
                    box-shadow: 0 0 2px $orange--tint-9;
                }
            }

            span {
                border: 1px solid $orange--tint-8;
                border-radius: 5px;
                color: $orange--tint-9;
                display: block;
                font-size: 20px;
                opacity: 1;
                padding: 9px 8px;
                transform: rotate(90deg);
                transition: opacity 0.5s ease;

                &:before{
                    display: block;
                    transition: all 0.5s ease;
                    transition-delay: 0.5s;
                }

                &.hidden{ opacity: 0; }

                &.icon--back{
                    &:before{
                        transform: rotateY(180deg);
                    }
                }
            }
        }
    }
</style>